export const fptiMetadata = {
  BP_PGRP: 'main:bizprofileweb:sellermgmt:viewprofile',
  BP_SOURCE: 'viewprofile',
  BP_PAGE: 'viewprofile',
  BP_VIEWED: 'seller_b_profile_viewed:',
  BP_CARD_VIEWED: 'seller_b_profile_card_viewed:',
  BP_DATA_VIEWED: 'seller_b_profile_data_viewed:',
  SUBSCRIBE_SUCCESS_EVENT: 'seller_b_profile_subscribed_success',
  UNSUBSCRIBE_SUCCESS_EVENT: 'seller_b_profile_unsubscribed_success',
  SUBSCRIBE_FAILURE_EVENT: 'seller_b_profile_subscribed_failure',
  UNSUBSCRIBE_FAILURE_EVENT: 'seller_b_profile_unsubscribed_failure',
  TOAST_SUBSCRIBE_SUCCESS_EVENT:
    'seller_b_profile_subscribed_banner_view_success',
  TOAST_UNSUBSCRIBE_SUCCESS_EVENT:
    'seller_b_profile_unsubscribed_banner_view_success',
  TOAST_SUBSCRIBE_FAILURE_EVENT:
    'seller_b_profile_subscribed_banner_view_failure',
  TOAST_UNSUBSCRIBE_FAILURE_EVENT:
    'seller_b_profile_unsubscribed_banner_view_failure',
}

export const VIEWER_TYPES = {
  SELLER: 'seller',
  GUEST: 'guest',
  BUYER: 'buyer',
}

export const fptiOptions = {
  SHARE_BTN_LINK: 'seller_b_profile_shared',
  SUBSCRIBE_BTN_LINK: 'seller_b_profile_subscribe_click',
  UNSUBSCRIBE_BTN_LINK: 'seller_b_profile_unsubscribe_click',
  PAY_BTN_LINK: 'seller_b_profile_pay',
}

export const eventNames = {
  [fptiMetadata.BP_CARD_VIEWED + VIEWER_TYPES.GUEST]: 'bp_viewed_guest_web',
  [fptiMetadata.BP_CARD_VIEWED + VIEWER_TYPES.BUYER]: 'bp_viewed_buyer_web',
  [fptiMetadata.BP_CARD_VIEWED + VIEWER_TYPES.SELLER]: 'bp_viewed_seller_web',
  [fptiMetadata.BP_DATA_VIEWED + VIEWER_TYPES.GUEST]:
    'bp_data_viewed_guest_web',
  [fptiMetadata.BP_DATA_VIEWED + VIEWER_TYPES.BUYER]:
    'bp_data_viewed_buyer_web',
  [fptiMetadata.BP_DATA_VIEWED + VIEWER_TYPES.SELLER]:
    'bp_data_viewed_seller_web',
  [fptiMetadata.BP_VIEWED + VIEWER_TYPES.GUEST]: 'bp_page_viewed_guest_web',
  [fptiMetadata.BP_VIEWED + VIEWER_TYPES.BUYER]: 'bp_page_viewed_buyer_web',
  [fptiMetadata.BP_VIEWED + VIEWER_TYPES.SELLER]: 'bp_page_viewed_seller_web',
}

export const BUYER_CLICKED_PAY_BUTTON_FPTI =
  'business_profile_buyer_view_pay_click'
